import Vue from 'vue'
import App from './App.vue'
import router from './router'
import toastRegistry from './components/NewToast/index'
// 引入谷歌图标库
import 'material-design-icons/iconfont/material-icons.css'

import { REGISTRATION_URL } from './config/consts'

// require("@/mock");

import 'muse-ui/lib/styles/base.less'
import {
  Alert,
  AppBar,
  AutoComplete,
  Avatar,
  Badge,
  BottomNav,
  BottomSheet,
  Breadcrumbs,
  Button,
  Card,
  Checkbox,
  Chip,
  DateInput,
  DataTable,
  Dialog,
  Divider,
  Drawer,
  ExpansionPanel,
  Form,
  Grid,
  GridList,
  Helpers,
  Icon,
  List,
  LoadMore,
  Menu,
  Pagination,
  Paper,
  Picker,
  Popover,
  Progress,
  Radio,
  Select,
  SlidePicker,
  Slider,
  Snackbar,
  Stepper,
  SubHeader,
  Switch,
  Tabs,
  TextField,
  Tooltip,
} from 'muse-ui'

import 'muse-ui/lib/styles/theme.less'

// 引入弹窗插件
import 'muse-ui-message/dist/muse-ui-message.css'
import Message from 'muse-ui-message'

import 'muse-ui-loading/dist/muse-ui-loading.css'
import Loading from 'muse-ui-loading'

require('swiper/dist/css/swiper.css')

// Vue.use(Swiper);

Vue.use(Loading)
Loading.config({
  // overlayColor: "hsla(0,0%,100%,.9)",
  overlayColor: 'transparent',
  color: '#214ecf',
})

Vue.use(Alert)
Vue.use(AppBar)
Vue.use(AutoComplete)
Vue.use(Avatar)
Vue.use(Badge)
Vue.use(BottomNav)
Vue.use(BottomSheet)
Vue.use(Breadcrumbs)
Vue.use(Button)
Vue.use(Card)
Vue.use(Checkbox)
Vue.use(Chip)
Vue.use(DateInput)
Vue.use(DataTable)
Vue.use(Dialog)
Vue.use(Divider)
Vue.use(Drawer)
Vue.use(ExpansionPanel)
Vue.use(Form)
Vue.use(Grid)
Vue.use(GridList)
Vue.use(Helpers)
Vue.use(Icon)
Vue.use(List)
Vue.use(LoadMore)
Vue.use(Menu)
Vue.use(Pagination)
Vue.use(Paper)
Vue.use(Picker)
Vue.use(Popover)
Vue.use(Progress)
Vue.use(Radio)
Vue.use(Select)
Vue.use(SlidePicker)
Vue.use(Slider)
Vue.use(Snackbar)
Vue.use(Stepper)
Vue.use(SubHeader)
Vue.use(Switch)
Vue.use(Tabs)
Vue.use(TextField)
Vue.use(Tooltip)
Vue.use(Message)
Vue.use(toastRegistry)

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

Vue.prototype.$backTop = function (elem) {
  if (!elem || elem.nodeType !== 1) return false

  elem.scrollTop = 0
}

Vue.prototype.$setHtmlTitle = function (title) {
  document.title = !title ? this.$route.meta.title : title //  + "-" + this.$route.meta.title
}

Vue.prototype.$courseHaveToPay = function (item) {
  const haveToPay = item.isVisible === 0
  if (haveToPay) {
    this.$confirm('无法使用该课程，请先购买或报名。', '提示', {
      type: 'warning',
      okLabel: '去购买',
    }).then(({ result }) => {
      if (result) {
        router.push({ path: '/order', query: { subject_id: item.id } })
      }
    })
  }
  return haveToPay
}
Vue.prototype.$courseExamHaveToPay = function (item) {
  const haveToPay = item.allow_practise === 0
  if (haveToPay) {
    this.$confirm('无法使用章节练习/模拟考试，请先购买或报名。', '提示', {
      type: 'warning',
      okLabel: '去购买',
    }).then(({ result }) => {
      if (result) {
        router.push({ path: '/order', query: { subject_id: item.id } })
      }
    })
  }
  return haveToPay
}

window.vm = new Vue({
  data() {
    return {
      navType: 1,
      isStudent: false,
      showMineCourse: false, // 显示自己的课程
      wechatInfo: {
        nickname: '',
        headimgurl: '',
        phone: '',
      },
      REGISTRATION_URL,
    }
  },
  router,
  render: (h) => h(App),
}).$mount('#app')
